import { cleanInput } from '@exodus/basic-utils'
import { getUrlWithOrderId, joinUrl, omitUndefinedValues } from '../utils.js'
import { ORDER_TYPES, PROVIDERS } from '../constants.js'
import sardineAdapter from './adapter.js'
import { DEFAULT_FIAT_PRECISION, ENABLED_ASSETS, PAYMENT_METHOD_NAMES } from './constants.js'

export const getWidgetUrl = async ({
  assets: assets_ = ENABLED_ASSETS,
  clientToken,
  fetchToken,
  fromAmount,
  fromAsset,
  fromAssetPrecision = DEFAULT_FIAT_PRECISION,
  finalUrl,
  orderId,
  paymentMethod,
  toAmount,
  toAsset = [],
  type = ORDER_TYPES.buy,
  url = 'https://crypto.sardine.ai',
  walletAddress,
  origin,
} = {}) => {
  if (type !== ORDER_TYPES.buy) {
    throw new Error('Only `buy` orders are accepted')
  }

  if (fromAmount && toAmount) {
    throw new Error('`fromAmount` and `toAmount` are mutually exclusive')
  }

  if (fromAmount && !fromAsset) {
    throw new Error('`fromAsset` is required when `fromAmount` is provided')
  }

  if (toAmount && toAsset.length === 0) {
    throw new Error('`toAsset` is required when `toAmount` is provided')
  }

  if (!clientToken && typeof fetchToken === 'function') {
    if (!paymentMethod) {
      throw new Error('`paymentMethod` is required when `fetchToken` is provided')
    }

    ;({ clientToken } = await fetchToken({
      provider: PROVIDERS.sardine,
      referenceId: orderId,
      paymentMethodTypeConfig: {
        default: paymentMethod,
        enabled: [
          PAYMENT_METHOD_NAMES.us_debit,
          PAYMENT_METHOD_NAMES.us_credit,
          PAYMENT_METHOD_NAMES.international_debit,
          PAYMENT_METHOD_NAMES.international_credit,
          PAYMENT_METHOD_NAMES.bank,
          PAYMENT_METHOD_NAMES.ach,
          PAYMENT_METHOD_NAMES.card,
        ],
      },
    }))
  }

  const providerAssets = toAsset.map((asset) =>
    sardineAdapter.fromExodusToProviderAsset(asset, assets_).split('_')
  )

  const fiatAmount = fromAmount ? cleanInput(String(fromAmount), fromAssetPrecision) : fromAmount
  const [cryptoAsset, network] = providerAssets[0]
  const searchParameters = new URLSearchParams(
    omitUndefinedValues({
      address: walletAddress,
      redirect_url: getUrlWithOrderId(
        orderId,
        finalUrl,
        omitUndefinedValues({ provider: PROVIDERS.sardine, origin })
      ),
      fiat_amount: fiatAmount,
      fixed_fiat_currency: fromAsset,
      fixed_asset_type: cryptoAsset.toUpperCase(),
      fixed_network: network,
      client_token: clientToken,
    })
  )

  return joinUrl(url, `?${searchParameters}`)
}
